import styled from "styled-components"

export default {
    "ParentWrapper": styled.div`
        /* 웹앱 프로젝트이므로 관련 사이즈 지정 */
        min-width: 320px; /* Mobile 기준 최소 Viewport 설정 */
        max-width: 767px; /* Mobile 기준 최대 Viewport 설정 */
        height: auto;
        min-height: 100vh;
        margin: 0 auto; /* PC버전으로 열람시 가운데 정렬이 될 수 있게 */
        display: flex;
        flex-direction: column;
        background-color: ${({ theme }) => theme.color.white};
    `,
}